/**
 * Leaving a page with unsaved work (Search / Contact Search filters): the
 * page registers a guard; the sidebar asks it before navigating. A guard
 * returns true when it has taken over (it shows its own "save first?"
 * prompt and calls proceed() if the user leaves anyway).
 * Closing / reloading the tab is covered separately (beforeunload).
 */
type Guard = (proceed: () => void) => boolean;
let current: Guard | null = null;
// Set when the page itself moves on after finishing the work (e.g. a search
// added to a project opens that project): no "leave?" prompts from then on.
let released = false;

export function setLeaveGuard(g: Guard | null) {
  current = g;
  released = false;
}

export function releaseLeaveGuard() {
  released = true;
}

export const leaveGuardReleased = () => released;

export function requestLeave(proceed: () => void) {
  if (current && !released && current(proceed)) return;
  proceed();
}
